<div class="trials">

  <div class="patient-detail-head">
    <div class="back-button">
      <div backBtn class="back-btn" [extraClass]="'patient-detail-back-btn'"></div>
    </div>

    <div class="row">
      <div class="col-6">
        <span class="patient-name">
          <div class="patient-badges">
            <span class="patient-state-badge status-{{ patient.patientState | lowercase }}"
              *ngIf="patientLoaded">{{patient.patientState}}</span>
            <span class="patient-study-phase-badge phase-{{ patient.studyPhase | lowercase }}"
              *ngIf="patientLoaded && patient.studyPhase && patient.trialBrand?.toLowerCase() === 'adarx'">{{patient.studyPhase}}</span>
          </div>
          <span *ngIf="patientLoaded">{{ patient.getFullName() }}</span>
          <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
        </span>
      </div>

      <div class="col-6">
        <div class="buttons" *ngIf="patientLoaded">
          @if (patient.patientState === 'Pending') {
          <!-- Start: Approve Patient Button -->
          @if (authService.hasPermission(Permissions.PatientApprove)) {
          <a (click)="patientApproveModal.show(patient)" class="btn btn-primary btn-narrow">Approve</a>
          }
          <!-- End: Approved Patient Button -->

          <!-- Start: Reject Patient Button -->
          @if (authService.hasPermission(Permissions.PatientApprove)) {
          <a (click)="onHandleRejectPatient()" class="btn btn-secondary btn-narrow">Reject</a>
          }
          <!-- End: Reject Patient Button -->
          } @else {
          <!-- Start: Email Invite Button -->
          <a class="btn btn-outline btn-light btn-narrow" *ngIf="!patient.patientNotOnApp"
            (click)="onSendToPatient()">Email App Invitation</a>
          <!-- End: Email Invite Button -->

          <!-- Start: Set Password Button -->
          <a (click)="setPasswordModal.show(patientTrialId)" class="btn btn-outline btn-narrow"
            *ngIf="(authService.hasRole(RoleNames.ProductAdministrator) || authService.hasRole(RoleNames.ProjectCoordinatorTravel) || authService.hasRole(RoleNames.ProjectCoordinatorExpenses) || authService.hasRole(RoleNames.CallCentre))  && !patient.patientNotOnApp">Set
            Password</a>
          <!-- End: Set Password Button -->

          <!-- Start: Send Notification Button -->
          <a class="btn btn-secondary btn-narrow" (click)="onOpenNotificationPopup()"
            *ngIf="patient.trialAllowActivityCentre && authService.hasPermission(Permissions.PatientWrite) && !patient.patientNotOnApp">Send
            Notification</a>
          <!-- End: Send Notification Button -->

          <!-- Start: Edit Patient Button -->
          <a (click)="patientEditModal.show(patient.id)" class="btn btn-primary btn-narrow"
            *ngIf="authService.hasPermission(Permissions.PatientWrite)">Edit</a>
          <!-- End: Edit Patient Button -->

          }
        </div>
      </div>
    </div>

    <div class="row" *ngIf="patient.syncFailed">
      <div class="col">
        <div class="resync-failed">
          <div class="button-wrap">
            <app-button text="Resync" size="sm" [isBusy]="resyncing" (click)="resyncPatient()" />
          </div>
          <p>Attempts to synchronise this patient have failed.</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="patient-info-boxes" style="margin-bottom: 20px;">
          <div class="box-label">
            <label>Patient Code</label>
            <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
            <p *ngIf="patientLoaded">{{ patient.id !== undefined ? patient.patientCode : ''}}</p>
          </div>

          <div class="box-label">
            <label>Patient Email Address</label>
            <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
            <p *ngIf="patient.id !== undefined">
              {{ patient.externalEmail ? patient.externalEmail : patient.email}}
            </p>
            <span class="badge badge-info" style="padding: 1px 5px 0 5px; font-weight: 400;"
              *ngIf="patientLoaded && patient.apiConsumerName !== null && patient.apiConsumerName !== ''">{{patient.apiConsumerName}}</span>
          </div>

          <div class="box-label">
            <label>Phone Number</label>
            <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
            <p *ngIf="patient.id !== undefined">
              {{ patient.phone ? (patient.phone.startsWith('+') ? '00' + patient.phone.substring(1) : patient.phone) : '-' }}
            </p>
          </div>

          <div class="box-label">
            <label>Home Address</label>
            <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
            <p *ngIf="patientLoaded">{{ patient.id !== undefined && patient.getFullAddress() !== '' ?
              patient.getFullAddress() : '-' }}</p>
          </div>

          <div class="box-label">
            <label>Trial Code</label>
            <ngx-skeleton-loader class="d-block" *ngIf="!patientLoaded"></ngx-skeleton-loader>
            <p *ngIf="patientLoaded">
              <a routerLink="/trial/{{patient.trialId}}" *ngIf="authService.hasPermission(Permissions.TrialRead)">{{
                patient.trialLabel }}</a>
              <span *ngIf="!authService.hasPermission(Permissions.TrialRead)">{{ patient.trialLabel }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <app-patient-login-info [patient]="patient"></app-patient-login-info>

    <div class="row" *ngIf="patient.id !== undefined && patient.note !== null && patient.note !== ''">
      <div class="col-12">
        <div class="patient-important-information">
          <label>Important Information</label>
          <p>{{ patient.note }}</p>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="patient.id !== undefined">
      <div class="col-6">
        <div class="patient-consent" *ngIf="authService.hasPermission(Permissions.TrialPolicyRead)">
          <p class="added-by" *ngIf="patient.consent && patient.consentType.toLowerCase() === 'app'">Consented via app:
            {{
            patient.consentDate | date: 'd MMM yyyy' }}</p>
          <p class="added-by" *ngIf="patient.consent && patient.consentType.toLowerCase() === 'cms'">CMS-observed
            consent:
            <span style="font-weight: 300">{{ patient.consentDate | date: 'd MMM yyyy' }}</span></p>
          <p class="added-by" *ngIf="!patient.consent">!!!CONSENT NOT YET OBSERVED!!!</p>

          <p><strong>Site: </strong>
            <span style="font-weight: 300"><ng-container *ngIf="currentPatientTrial?.siteNumber">{{ currentPatientTrial.siteNumber }} </ng-container>{{ patient.siteName }}</span>
          </p>

          <p><strong>Policy: </strong><a
              routerLink="/trial/{{patient.trialId}}/policy/{{patient.trialPolicyId}}/edit">{{patient.trialPolicyName}}</a>
          </p>
        </div>
      </div>

      <div class="col-6">
        <div class="patient-approved" style="text-align: right;">
          @if (patient.patientState !== 'Pending') {
          <p class="added-by">Approved by {{ patient.approvedByName }} on {{ patient.approvedDate | date: 'd MMM yyyy'
            }}
            at {{ patient.approvedDate | date: 'h:mm aaa' }}</p>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="details-view">

    <div class="tabs-wrap" [ngClass]="{'visibility-hidden': patient.id === undefined}">
      <div class="mobile-tabs">
        <select id="nav-tabs-select" class="selectpicker">
          <option value="#patient-visits-anchor" *ngIf="authService.hasPermission(Permissions.PatientVisitsRead)">Visits
          </option>
          <option value="#patient-expenses-anchor"
            *ngIf="authService.hasPermission(Permissions.PatientExpenseWrite) || authService.hasPermission(Permissions.PatientExpenseRead)">
            Expenses</option>
          <option value="#patient-additional-details-anchor"
            *ngIf="authService.hasPermission(Permissions.PatientDetailsRead)">Additional Details</option>
          <option value="#patient-notes-anchor" *ngIf="authService.hasPermission(Permissions.PatientNotesRead)">Notes
          </option>
          <option value="#patient-activity-anchor" *ngIf="authService.hasPermission(Permissions.PatientActivityRead)">
            Activity</option>
          <option value="#patient-change-log-anchor"
            *ngIf="authService.hasPermission(Permissions.PatientChangeLogRead)">Change Log</option>
        </select>
      </div>

      <ul class="nav nav-tabs" [ngClass]="{'visibility-hidden': patient.id === undefined}">
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientVisitsRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'visits'}" (click)="onSelectTab('visits')">Visits</a>
        </li>
        <li class="nav-item"
          *ngIf="(authService.hasPermission(Permissions.PatientExpenseWrite) || authService.hasPermission(Permissions.PatientExpenseRead)) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'expenses'}"
            (click)="onSelectTab('expenses')">Expenses</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientDetailsRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'additional-details'}"
            (click)="onSelectTab('additional-details')">Additional Details</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientNotesRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'notes'}" (click)="onSelectTab('notes')">Notes</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientActivityRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'activity'}"
            (click)="onSelectTab('activity')">Activity</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientChangeLogRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'change-log'}"
            (click)="onSelectTab('change-log')">Change Log</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoRead) && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'payment-info'}"
            (click)="onSelectTab('payment-info')">Payment Info</a>
        </li>
        <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientDocumentsRead)">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'documents'}"
            (click)="onSelectTab('documents')">Documents</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientEdiaryRead) && patient.diaryEnabled && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'diary'}" (click)="onSelectTab('diary')">Maze
            E-Diary</a>
        </li>
        <li class="nav-item"
          *ngIf="authService.hasPermission(Permissions.PatientEdiaryRead) && patient.genericDiaryEnabled && patient.patientState !== 'Pending'">
          <a class="nav-link" [ngClass]="{'active': selectedTab == 'generic-diary'}"
            (click)="onSelectTab('generic-diary')">E-Diary</a>
        </li>
      </ul>
    </div>

    @if (patient.id) {
    <div class="tab-content" id="details-view-tab-content">

      @if (authService.hasPermission(Permissions.PatientVisitsRead) && selectedTab === 'visits') {
      <app-patient-detail-visits #visitsTab></app-patient-detail-visits>
      }

      @if (selectedTab === 'expenses') {
      <app-patient-detail-expenses #expensesTab [patientId]="patient.id" [patientTrialId]="patientTrialId"
        [trialAllowsExpenses]="patient.trialAllowsExpenses"></app-patient-detail-expenses>
      }

      @if (selectedTab === 'additional-details') {
      <app-patient-detail-additional #additionalDetailsTab (patientInfoUpdated)="loadPatient()"
        [patient]="patient"></app-patient-detail-additional>
      }

      @if (selectedTab === 'notes') {
      <app-patient-detail-notes #notesTab [patientId]="patient.id"></app-patient-detail-notes>
      }

      @if (selectedTab === 'activity') {
      <app-patient-detail-activity #activityTab [patientId]="patient.id"></app-patient-detail-activity>
      }

      @if (selectedTab === 'change-log') {
      <app-patient-detail-change-log #changeLogTab [patientTrialId]="patientTrialId"></app-patient-detail-change-log>
      }

      @if (selectedTab === 'payment-info') {
      <app-patient-payment-info [trialId]="patient.trialId" [patientTrialId]="patientTrialId"
        [patientBasicInfo]="patientBasicInfo" #paymentInfoTab></app-patient-payment-info>
      }

      @if (selectedTab === 'documents') {
      <app-patient-documents [patientTrialId]="patientTrialId" #documentsTab></app-patient-documents>
      }

      @if (selectedTab === 'diary') {
      <app-patient-diary [patientTrialId]="patientTrialId" [trialId]="patient.trialId"></app-patient-diary>
      }

      @if (selectedTab === 'generic-diary') {
      <app-patient-ediaries [patientTrialId]="patientTrialId" [trialId]="patient.trialId"></app-patient-ediaries>
      }

    </div>
    }

  </div>

</div>

<!-- Start: Set password modal -->
<app-patient-set-password-modal #setPasswordModal />
<!-- End: Set password modal -->

<!-- Start: Notification modal -->
<app-modal #notificationModal>
  <div class="modal-header">
    <h2 class="modal-title">Send Notification</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="notificationForm">
      <div class="form-group">
        <label>Title</label>
        <input type="text" formControlName="title" maxlength="50">
      </div>
      <div class="form-group">
        <label>Content</label>
        <textarea class="form-control" formControlName="content" maxlength="175"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="notificationModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>

      <div class="col-6">
        <a (click)="onSubmitNotification()" class="btn btn-primary" [ngClass]="{'disabled': notificationForm.invalid}">
          <span *ngIf="notificationFormIsProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">Loading...</span>
          </span>
          <span *ngIf="!notificationFormIsProcessing">Send Notification</span>
        </a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Notification modal -->

<app-patient-edit-modal #patientEditModal (patientUpdated)="loadPatient()"></app-patient-edit-modal>

<app-patient-approve-modal #patientApproveModal (approved)="loadPatient()"></app-patient-approve-modal>
